/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'

import Button from '../button'

export default props => {
  return <header
    css={{
      position: 'fixed',
      width: 310,
      zIndex: 1000
    }}
    sx={{
      left: 4,
      top: 4,
      p: 3,
      backgroundColor: 'white',
      borderRadius: 2,
      color: 'primary',
    }}
    >
    <Button>ARRAY.DIO</Button>
  </header>
}